export class AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.attributeTypeMap;
    }
    constructor() {
    }
}
